// import { CircularProgress, Box, styled } from "@mui/material";

// // STYLED COMPONENT
// const StyledLoading = styled("div")({
//   width: "100%",
//   height: "100%",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   "& img": {
//     width: "auto",
//     height: "25px"
//   },
//   "& .circleProgress": {
//     position: "absolute",
//     left: -7,
//     right: 0,
//     top: "calc(50% - 25px)"
//   }
// });

// export default function Loading() {
//   return (
//     <StyledLoading>
//       <Box position="relative">
//         {/* <img src="/assets/images/logo-circle.svg" alt="" /> */}
//         <img src="/assets/images/venue-logo-loading.svg" alt="" />
//         <CircularProgress className="circleProgress" />
//       </Box>
//     </StyledLoading>
//   );
// }


import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import Box from '@mui/material/Box';
import LoaderGIF from "assets/img/loader/venuelog_loading.gif"


const bounceIn = keyframes`
  0% {
    opacity: 0.3;
    transform: scale(0.3);
  }
  60% {
    opacity: 1;
    transform: scale(1);
  }
  80% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
    opacity: 0.2;
  }
`;

const PageLoaderContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  height: '100vh',
  width: '100vw',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  '&:after': {
    content: '""',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    display: 'block',
    backgroundColor: '#dddfe4',
    zIndex: -1,
    backdropFilter: 'blur(10px)',
  },
}));

const PageLoaderImg = styled('img')(({ theme }) => ({
  width: '160px',
  animation: `${bounceIn} infinite ease-in 2s`,
}));

function PageLoader() {
  return (
    <PageLoaderContainer>
      <PageLoaderImg src={LoaderGIF} alt="loader" />
    </PageLoaderContainer>
  );
}

export default PageLoader;
